import { NavBar } from "antd-mobile";
import { LeftOutline } from "antd-mobile-icons";
import { useNavigate } from "react-router-dom";

export const Header: React.FC<{
    title: string;
    backRoute?: string;
}> = ({
          title,
          backRoute,
      }) => {
    const navigate = useNavigate();
    const handleBack = () => {
        const route = backRoute || "/pda/home";
        navigate(route);
    };
    return (
        <NavBar backIcon={<LeftOutline />} onBack={handleBack}>{title}</NavBar>
    )
}